import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { getGEITWorkspaces } from "services/ConfigServices";
import { dashboardText } from "variables/MBM/geb";
import { viewmenuData } from "variables/MITM/lists/geit";
import CustomSelect from "components/Input/CustomSelect.js";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle";
import tablestyles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Button from "components/CustomButtons/Button.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { withStyles } from "@mui/styles";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { deleteGEITWorkspace } from "services/ConfigServices";
import WorkspaceDialog from "./Workspace/WorkspaceDialog";
import Dashboard from "./Dashboard";
import ControlVT from "./Control/ControlVT";

const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "0",
  paddingTop: "0",
  paddingBottom: "0px",
  paddingRight: "2px",
  paddingLeft: "2px",
  fontFamily: '"Source Sans Pro",sans-serif',
  color: "#000000",
  background: "transparent",
  boxShadow: "none",
};

const WorkspaceContainer = styled.div`
  margin-top: 10px;
`;
// const WorkspaceContainer = styled.div`
//   height: calc(100vh - 160px);
// `;


const ToolBar = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ToolBarRight = styled.div`
  display: flex;
`;

const useTableStyles = makeStyles(tablestyles);
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles((theme) => ({
  planicon: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planicongreen: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    color: "#91C73C",
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planmenu: {
    display: 'flex',
    aligItems: "flex-end",
  },
  plansubmenu: {
    display: 'flex',
    marginTop: 7,
    marginLeft: 5,
  },
  planmenuicon: {
    width: "20px",
    height: "20px",
  },
  planmenubutton: {
    background: "#FFFFFF"
  },
  planmenubuttonpressed: {
    background: "#91C73C"
  },
}));

const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const getDateBeginFromPeriod = (period) => {
  let date = moment();
  if (period === 'oneweek') {
    date = date.add(-7, 'd');
    // date = date.set('h',0);
  }
  return date.format("YYYY-MM-DD");
}
const getDateEndFromPeriod = (period) => {
  let date = moment();
  if (period === 'oneweek') {

    // date = date.set('h',0);
  }
  return date.format("YYYY-MM-DD");
}

const Workspace = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mitm_geit_admin = permis.includes("mitm_geit_admin");
  const mitm_control_access = permis.includes("mitm_control_access");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [editionmode, setEditionmode] = useState(false);

  const [workspaces, setWorkspaces] = useState([]);
  const [workspacelist, setWorkspacelist] = useState([]);
  const [workspace, setWorkspace] = useState("");
  const [openMenuworkspace, setOpenmenuworkspace] = useState(null);
  const [openeditworkspace, setOpeneditworkspace] = useState(false);
  const [currentWorkspace, setCurrentWorkspace] = useState("");
  const [view, setView] = useState("dashboard");

  const handleAddWorkspace = (event) => {
    setOpenmenuworkspace(null)
    setCurrentWorkspace("");
    handleOpenworkspace();
  }
  const handleEditWorkspace = (event) => {
    setOpenmenuworkspace(null)
    setCurrentWorkspace(workspaces.find((wp) => wp.id == workspace));
    handleOpenworkspace();
  }
  const handleDeleteWorkspace = (event) => {
    setOpenmenuworkspace(null)
    axios
      .delete(
        deleteGEITWorkspace(workspace),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", dashboardText.workspacedeleted);
          setWorkspace("");
          refreshWorkspaceList();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }

  //Workspace  
  const handleOpenworkspace = (event) => { setOpeneditworkspace(true); };
  const handleCloseworkspace = (event) => { setOpeneditworkspace(false); };
  const handleCloseMenuworkspace = (event) => { setOpenmenuworkspace(null) };
  const handleClickMenuworkspace = (event) => { setOpenmenuworkspace(event.currentTarget) };
  const handleEditionmodeChange = (event) => { setEditionmode(!editionmode); };
  const handleWorkspaceChange = (event) => { setWorkspace(event.target.value); };
  const handleViewChange = (event) => { setView(event.target.value); };

  const emptyWorkspace = () => {
    setWorkspace();
    setCurrentWorkspace();
  }

  //worskpaces list
  useEffect(() => {
    refreshWorkspaceList();
  }, [chartIdGroup]);

  const refreshWorkspaceList = (selectedid) => {
    emptyWorkspace();
    axios
      .get(getGEITWorkspaces(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setWorkspaces(res.data?.workspaces || []);
        let workspacedefault = "";
        let workspacelisttmp = res.data?.workspaces?.map((workspace) => {
          if (selectedid) {
            if (workspace.id == selectedid)
              workspacedefault = workspace.id;
          }
          else if (workspace.idgroup == chartIdGroup && workspace.parameters?.isdefault)
            workspacedefault = workspace.id;
          return { id: workspace.id, name: workspace.parameters?.name || '' }
        }
        );
        setWorkspacelist(workspacelisttmp);
        if (workspacedefault)
          setWorkspace(workspacedefault);
      });
  };



  return (
    <WorkspaceContainer>
      <GridContainer sx={{ height: 0.99 }} alignContent="flex-start">
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <ToolBar>
            <div style={{ display: "flex" }}>
              <CustomSelect
                marginTop={0}
                width={200}
                inputTitle={dashboardText.workspaces}
                selectValue={workspace}
                handleSelectValueChange={handleWorkspaceChange}
                data={workspacelist}
                small
              />
              {editionmode ?
                <>
                  <Button
                    id="basic-button"
                    aria-controls={openMenuworkspace ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openMenuworkspace ? 'true' : undefined}
                    onClick={handleClickMenuworkspace}
                    style={menuButtonStyle}
                  >
                    <MenuIcon />
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={openMenuworkspace}
                    open={Boolean(openMenuworkspace)}
                    onClose={handleCloseMenuworkspace}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <MenuItem onClick={handleAddWorkspace} key={`handleaddplan`}>
                      {dashboardText.menuaddworkspace}
                    </MenuItem>
                    {workspace &&
                      <MenuItem onClick={handleEditWorkspace} key={`handleeditplan`}>
                        {dashboardText.menumeditworkspace}
                      </MenuItem>}
                    {
                      workspace &&
                      <MenuItem onClick={handleDeleteWorkspace} key={`handledelplan`}>
                        {dashboardText.menumdelworkspace}
                      </MenuItem>}

                  </Menu>
                </>
                : <></>
              }
            </div>
            <ToolBarRight>
              {
                (mitm_geit_admin && (view === "dashboard")) ?
                  <div>
                    <CustomSwitch
                      style={{ margin: "0rem 0rem 0rem 0rem", display: "flex", alignItems: "center" }}
                      inputTitle={dashboardText.editionmode}
                      checkedState={editionmode}
                      handleSwitchChange={handleEditionmodeChange}
                    />
                  </div> :
                  <></>
              }
              {
                mitm_control_access ?
                  <CustomSelect
                    marginTop={0}
                    width={200}
                    inputTitle={""}
                    selectValue={view}
                    handleSelectValueChange={handleViewChange}
                    data={viewmenuData}
                    small
                  /> : <></>
              }

            </ToolBarRight>
          </ToolBar>
        </GridItem>
        {
          (workspace && (view === "dashboard")) ?
            <Dashboard
              currentWorkspace={workspaces.find((wp) => wp.id == workspace)}
              editionmode={editionmode}
            /> : (workspace && (view === "control")) ?
              <ControlVT
                currentWorkspace={workspaces.find((wp) => wp.id == workspace)}
              /> : <></>
        }

      </GridContainer>
      {/* Création/Edition de l'environnement */}
      <Dialog
        onClose={handleCloseworkspace}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openeditworkspace}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseworkspace}>
          {currentWorkspace ? dashboardText.editworkspace : dashboardText.newworkspace}
        </CustomDialogTitle>
        <DialogContent dividers>
          {currentWorkspace ?
            <WorkspaceDialog
              currentWorkspace={currentWorkspace}
              closeModal={handleCloseworkspace}
              refetch={refreshWorkspaceList}
            /> : <WorkspaceDialog
              closeModal={handleCloseworkspace}
              refetch={refreshWorkspaceList}
            />
          }
        </DialogContent>
        <DialogActions />
      </Dialog>
      <NotificationContainer />
    </WorkspaceContainer>
  );
};

export default Workspace;
